import { SetStyles } from "../.././MyHelpers";
import { IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
import { SlotGameType1_2 } from "../SlotGameType1_2";

// namespace SlotGames2
// {
	export class LuckyHot2 extends SlotGameType1_2
	{
   
		////protected override freegameBonusFactory: FreegameBonusFactory2 = new LuckyHotFreegame2BonusFactory();
		protected override seconScreenHelpFactory:ISlideFactoryGeneric= new FactoryDoubleSlide();


        protected override PaytableLoaded(resourceManager: IReadOnlyResourceManager): void 
        {
        	super.PaytableLoaded(resourceManager);
        	SetStyles(this.view.querySelectorAll(".paytable-symbol-container"),
			{
				//HIDE BACKGROUND COLOR
				//backgroundColor:"rgba(0, 0, 0, 0.6)",
			});


        }
	}
// }